import React from 'react';

import './ItemPath.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';

const { RightArrow } = icons;

export default function ItemPath(props) {
  return (
    <section id="itemPath">
      {props.segments.map((segment, idx) => (
        <React.Fragment key={idx}>
          {link(
            <span>{segment.title}</span>,
            `/${segment.uri}`,
            props.nextLink
          )}

          {idx + 1 !== props.segments.length && <RightArrow />}
        </React.Fragment>
      ))}
    </section>
  );
}
